import React, { useEffect } from "react";
import { AnimatePresence, motion } from "motion/react";
import { ClampAlert } from "@/features/betslip/components/parts/ClampAlert";
import { Button } from "@picklebet/ui";
import { SettingsIcon } from "@picklebet/ui";
import { triggerHaptic } from "@/utilities/haptics";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";

import * as styles from "@/features/betslip/components/BulkActionBar.module.scss";

export const BulkActionBar = () => {
  const count = useBetslipStore((s) => s.bulkAcceptOddsChangeCount);
  const acceptAllOddsChanges = useBetslipStore((s) => s.acceptAllOddsChanges);
  const setOverlay = useBetslipStore((s) => s.setOverlay);

  const visible = count > 0;

  useEffect(() => {
    if (visible) triggerHaptic.error();
  }, [visible, count]);

  const handleAcceptAll = () => {
    acceptAllOddsChanges();
    triggerHaptic.success();
  };

  const handleOpenSettings = () => {
    setOverlay({ type: "quickPreferences" });
    triggerHaptic.click();
  };

  const label = `${count > 1 ? "Multiple " : ""}Odds Updated (${count})`;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ transform: "translate3d(0, 0, 0)" }}
          animate={{ transform: "translate3d(0, -100%, 0)" }}
          exit={{ transform: "translate3d(0, 0, 0)" }}
          className={styles.bulkActionBar}
          data-testid="bulk-action-bar"
        >
          <ClampAlert
            className={styles.alert}
            color="danger"
            icon={
              <Button
                variant="blurred"
                size="xxs"
                className={styles.roundBtn}
                onClick={handleOpenSettings}
                data-testid="bulk-action-settings"
              >
                <SettingsIcon />
              </Button>
            }
          >
            <div className={`${styles.flex} ${styles.alignCenter}`}>
              <div className={styles.flex1}>{label}</div>
              <div>
                <Button
                  variant="danger"
                  size="xxs"
                  onClick={handleAcceptAll}
                  data-testid="bulk-action-accept-all"
                >
                  Accept All
                </Button>
              </div>
            </div>
          </ClampAlert>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
